export default __webpack_public_path__ + "static/media/IBMPlexMono-Regular.9084e1a7.woff2";